<script setup lang="ts">
import { AkCheckbox } from '@ankorstore/design-system';
import { Item, ItemsFilterProps } from './types';
import FilterLabel from '@client/modules/discovery/ui/filters/filter-label.vue';
import ItemsFilter from '@client/modules/discovery/ui/filters/items-filter.vue';
import FilterIcon from '@client/modules/discovery/ui/filters/filter-icon.vue';
import FilterIconWithTooltip from '@client/modules/discovery/ui/filters/filter-icon-with-tooltip.vue';

defineOptions({
  name: 'CheckboxFilter',
});

defineProps<ItemsFilterProps>();

const emit = defineEmits(['checkboxChanged']);

const notifyCheckboxChanged = (item: Item) => emit('checkboxChanged', item);
</script>

<template>
  <ItemsFilter
    :items="items"
    :show-as-columns="showAsColumns"
  >
    <template #default="{ item }">
      <AkCheckbox
        :disabled="false"
        :value="item.value ?? 'undefined'"
        :checked="item.isRefined"
        @change="notifyCheckboxChanged(item)"
      >
        <div class="checkbox-filter__content">
          <FilterLabel
            :label="item.label"
            :count="item.count"
          />
          <FilterIconWithTooltip
            v-if="item.iconConfig && item.iconConfig.tooltip"
            :icon-config="item.iconConfig"
            :key-name="item.value"
            data-testid="filterIconWithTooltip"
          />
          <FilterIcon
            v-else-if="item.iconConfig"
            :icon-config="item.iconConfig"
            data-testid="filterIcon"
          />
        </div>
      </AkCheckbox>
    </template>
  </ItemsFilter>
</template>

<style lang="scss" scoped>
.checkbox-filter {
  &__content {
    @apply ds-flex ds-items-center ds-gap-1;
  }
}

:deep(.ak-checkbox__sidelabel) {
  @apply ds-mt-[3px];
}
</style>
